import React from 'react';
import { useAxiosState } from './useAxios';

const versionsUrl = `${process.env.REACT_APP_BACKEND}/kitchenVersions`;

interface ReleaseInput {
  version: string;
  date: number;
  commit: string;
  tickets: string[];
}

export interface Release {
  version: string;
  date: string;
  tickets: string[];
}

export function useReleases() {
  const { value: releasesInput, status, error } = useAxiosState<ReleaseInput[]>([], versionsUrl);

  const releases = React.useMemo<Release[]>(() => {
    const now = new Date();
    const oneYear = 365 * 24 * 60 * 60 * 1000;

    return releasesInput
      .map((v) => ({ ...v, date: new Date(v.date) }))
      .filter(({ date }) => {
        const diff = now.getTime() - date.getTime();
        return diff <= oneYear;
      })
      .map((v) => ({ ...v, date: v.date.toLocaleDateString() }))
      .reverse();
  }, [releasesInput]);

  return { releases, status, error };
}
